import { useEffect } from "react";

// simple IntersectionObserver-based reveal. add class="sh-reveal" to any element.
export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".sh-reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
